import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CopyRightInfo from "../../core/common/copyRightInfo";
import useFetch from "../../hooks/useFetch";
import PreLoader from "../../core/common/preLoader";
import { API } from "../../common/Constants";
import { DEFAULT_TENANT } from "../../environment";
import HeaderLogo from "../../core/common/headerLogo";


const ForgotPassword = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const {isLoading, error, data, status, callFetch } = useFetch();

  const [tenant, setTenant] = useState<string | undefined>(DEFAULT_TENANT);
  const [username, setUserName] = useState<string | undefined>(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);


  useEffect(() => {
      if(data && status && status < 299){
        navigation(routes.otpVerification + "?username=" + username + "&tenant=" + tenant);
        reset();
      }
  }, [status]);


  useEffect(() => {
    if(error){
      if(error.response?.data){
        setErrorMessage(error.response?.data)
      } else{
        setErrorMessage('Something went wrong please try again later.')
      }
    }
  }, [error]);

  const reset = () => {
      setUserName(undefined)
      setErrorMessage("")
  }

  const handleSubmit = (event:any) => {
    event.preventDefault()
    if(!username){
      setErrorMessage("Please provide username")
    } else {
      setErrorMessage("")
      callFetch(API.RESET_PASSWORD,
          'POST',
          {
              'X-Tenant-ID': tenant,
          },
          null,
          {
              username: username,
          }
      ).catch((err) => {});;
    }
  }


  return (
    <div className="container-fuild">
      <PreLoader showLoader={isLoading} />
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-04.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-7 mx-auto vh-100">
                <form className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <HeaderLogo />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Forgot Password?</h2>
                        <p className="mb-0">
                          If you forgot your password, well, then we'll email you
                          instructions to reset your password.
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Tenant Id</label>
                        <div className="input-group">
                          <span className="input-group-text border-end-0">
                            <i className="ti ti-building" />
                          </span>
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e) => setTenant(e.target.value)}
                            placeholder="Enter your tenant id"
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Username</label>
                        <div className="input-group">
                          <span className="input-group-text border-end-0">
                            <i className="ti ti-user" />
                          </span>
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            onChange={(e) => setUserName(e.target.value)}
                            placeholder="Enter your username"
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        {
                         <div className="text-center" style={{height:12}}>
                          {
                            errorMessage
                            ?
                              <>
                                <span className="link-danger">
                                <i className="ti ti-alert-triangle" /> {errorMessage}
                                </span>
                              </>
                            :
                              <></>
                            }
                          </div>
                         
                        }
                      </div>
                      <div className="mb-3">
                        <button type="submit" onClick={handleSubmit} className="btn btn-primary w-100">
                          Submit
                        </button>
                      </div>
                      <div className="text-center">
                        <h6 className="fw-normal text-dark mb-0">
                          Return to
                          <Link to={all_routes.login} className="ms-2 hover-a">
                            Sign In
                          </Link>
                        </h6>
                      </div>
                    </div>
                    <div className="mt-5 pb-4 text-center">
                     <CopyRightInfo />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ForgotPassword;